export default __webpack_public_path__ + "static/banner-tips-to-reduce-your-credit-card-interest-5ee7cc79e407347078455660d441c87a.jpg";